<template>
    <v-card>
        <v-card-title>
        <span class="headline">Clause Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newClause">
                <v-text-field :label="labels.clseNo" v-model="clauseForm.clseNo" :error-messages="errors.collect('clseNo')" data-vv-name="clseNo" :data-vv-as="labels.clseNo" v-validate="'required|param|max:6'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.clseNo}}</v-subheader>
                <div class="title">{{clauseForm.clseNo}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="clauseForm.clseTitle" :label="labels.clseTitle" :error-messages="errors.collect('clseTitle')" v-validate="'required|entry|max:400'" data-vv-name="clseTitle" :data-vv-as="labels.clseTitle"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea auto-grow box rows="1" v-model="clauseForm.clseTxt" :label="labels.clseTxt" :error-messages="errors.collect('clseTxt')" v-validate="'required|entry'" data-vv-name="clseTxt" :data-vv-as="labels.clseTxt"></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'clauseForm': Object,
    'newClause': Boolean
  },
  data() {
    return {
      labels: {
        clseNo: 'Clause Code*',
        clseTitle: 'Clause Title*',
        clseTxt: 'Clause Text*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.clauseForm.clseNo = undefined
      this.clauseForm.clseTitle = undefined
      this.clauseForm.clseTxt = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newClause) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.cargo.menu.createClause
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.clauseForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.cargo.menu.updateClause
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.clauseForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
